export const getReportRunIDFromURL = (url: string) => {
  const uuidPattern = /[0-9a-fA-F-]{36}/;
  const match = url.match(uuidPattern);
  if (match) return match[0];
};
